import { render, staticRenderFns } from "./QResource.vue?vue&type=template&id=63e234d2&scoped=true&"
import script from "./QResource.vue?vue&type=script&lang=js&"
export * from "./QResource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e234d2",
  null
  
)

export default component.exports